<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">IBAN</label>
            <div class="row">
                <div class="col">
                    <v-validator :errors="errors" parameter="IBAN" :watch="value.IBAN">
                        <input type="text" :disabled="getting" class="form-control" v-model="value.IBAN" placeholder="IBAN"/>
                    </v-validator>
                </div>
                <div class="col-auto">
                    <button :disabled="!value.IBAN" v-on:click="getInfo" class="btn btn-success btn-icon">
                        <b-spinner small v-if="getting"></b-spinner>
                        <feather-icon v-else icon="SearchIcon"></feather-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Banka</label>
            <v-validator :errors="errors" parameter="BankId" :watch="bank">
                <v-select-list v-model="bank" :disabled="getting" placeholder="Banka" label="Name" :options="banks"/>
            </v-validator>
        </div>
        <!-- <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-select-list disabled v-model="bankBranch" placeholder="Şube" label="Name" :options="branchs"/>
        </div> -->
        <div class="col-12 mb-1">
            <label class="form-label">Para Birimi</label>
            <v-validator :errors="errors" parameter="CurrencyUnitId" :watch="currency">
                <v-select-list v-model="currency" placeholder="Para Birimi" label="Name" :options="currencies"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Hesap Numarası</label>
            <v-validator :errors="errors" parameter="AccountCode" :watch="value.AccountCode">
                <input type="text" class="form-control" v-model="value.AccountCode" placeholder="Hesap Numarası"/>
            </v-validator>
        </div>
        <div class="col-12">
            <b-form-checkbox id="default" v-model="value.Default">Varsayılan</b-form-checkbox>
        </div>
        
        
    </div>
</template>

<script>
import { BFormCheckbox,BSpinner } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import BankApi from '@/api/bank'

export default {
    components:{
        BSpinner,
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            banks:[],
            branchs:[],
            currencies:[],
            getting:false,
        }
    },
    watch:{
        "value.BankId"(newValue,oldValue){
            if(newValue != oldValue){
                this.getBankBranchs()
                this.value.BankBranchId = null
                this.value.BankBranchName = null
            }
        }
    },
    mounted(){
        this.getBanks()
        this.getBankBranchs()
        this.getCurrencies()
    },
    methods:{
        getBanks(){
            HumanResourcesParameterApi.Bank.List().then(res=>{
                this.banks = res.data.Data
            })
        },
        getInfo(){
            this.getting = true
            BankApi.BankInformation(this.value.IBAN).then(res=>{
                this.getting = false
                if(res.data.Success){
                    this.value.BankId = res.data.Data.Id
                }else this.$result(res)
            }).catch(err=>{
                this.getting = false
                this.$result(null,err)
            })
        },
        getBankBranchs(){
            if(this.value.BankId){
                HumanResourcesParameterApi.BankBrach.List(this.value.BankId)
                .then(res=>{
                    this.branchs = res.data.Data
                })
            }
        },
        getCurrencies(){
            SystemDataApi.CurrencyUnit().then(res=>{
                this.currencies = res.data.Data
            })
        }
    },
    computed:{
        bank:{
            get:function(){
                return this.banks.find(b=>b.Id==this.value.BankId)
            },
            set:function(value){
                this.value.BankId = value?.Id || null
                this.value.BankName = value?.Name
            }
        },
        bankBranch:{
            get:function(){
                return this.branchs.find(b=>b.Id==this.value.BankBranchId)
            },
            set:function(value){
                this.value.BankBranchId = value?.Id || null
                this.value.BankBranchName = value?.Name
            }
        },
        currency:{
            get:function(){
                return this.currencies.find(b=>b.Id==this.value.CurrencyUnitId)
            },
            set:function(value){
                this.value.CurrencyUnitId = value?.Id || null
                this.value.CurrencyUnitName = value?.Name
            }
        }
    }
}
</script>

<style>

</style>